import type { VirtualItem } from "@tanstack/react-virtual";
import { observer } from "mobx-react-lite";
import type { DocumentTablePresentation } from "./documentTablePresentation";
import { TableContainerRow } from "./TableContainerRow";
import { TableDocumentRow } from "./TableDocumentRow";
import { TableFolderRow } from "./TableFolderRow";
import { TableFolderVersionRow, TableHistoryLinkRow } from "./TableHistoryRows";
import type { FlattenedItem } from "./useTableRows";
export const TableVirtualRows = observer(function TableVirtualRows(
  props: DocumentTablePresentation
) {
  return (
    <>
      {props.virtualRows.map((virtualRow) => (
        <TableVirtualRow
          key={virtualRowKey(props.flattenedItems[virtualRow.index], virtualRow)}
          {...props}
          virtualRow={virtualRow}
        />
      ))}
    </>
  );
});

function virtualRowKey(item: FlattenedItem, row: VirtualItem) {
  switch (item.kind) {
    case "folder":
      return row.key + "-folder-" + item.folder.id;
    case "container":
      return row.key + "-container-" + item.doc.id;
    case "folder-version":
      return row.key + "-folder-version";
    case "history-link":
      return row.key + "-history-link";
    default:
      return row.key;
  }
}
const TableVirtualRow = observer(function TableVirtualRow(
  props: DocumentTablePresentation & { virtualRow: VirtualItem }
) {
  const item = props.flattenedItems[props.virtualRow.index];
  if (item.kind === "folder") return <TableFolderRow {...props} item={item} />;
  if (item.kind === "container") return <TableContainerRow {...props} item={item} />;
  if (item.kind === "folder-version" && props.versionedFolder)
    return <TableFolderVersionRow {...props} item={item} />;
  if (item.kind === "history-link") return <TableHistoryLinkRow {...props} item={item} />;
  return <TableDocumentRow {...props} item={item} />;
});
